import Header from './Headers';

import SalesOrderAPI from './SalesOrderAPI';
import Config from '../config/config';
import Const from '../util/Constants';

class DashleadAPI {

  static list = (success, failure) => {
    fetch(Config.app.link + 'api/dashlead', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/dashlead/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (dashlead, success, failure) => {
    fetch(Config.app.link + 'api/dashlead/add-edit', new Header('POST', dashlead))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static listModel = (model, perPage, filters, success, failure) => {
    if(model === Const.TextSalesOrder) {
      const list = { filters, pagination: { currentPage: 1, perPage } };
      SalesOrderAPI.getList(list, success, failure);
    }
  }

  static data = (model, subModel, type, x, y, z, filters, success, failure) => {
    const report = { model, sub_model: subModel, type, x, y, z, filter: filters };
    fetch(Config.app.link + 'api/dashlead/data', new Header('POST', report))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static copy = (id, success, failure) => {
    fetch(Config.app.link + 'api/dashlead/copy/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/dashlead/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default DashleadAPI;